import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Select,
  Tabs,
  Row,
  Col,
} from 'antd';

import IntlMessages from '../../components/IntlMessage';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useIntl } from 'react-intl';
import postApi from '../../api/posts';

import UploadImage from '../../components/Elements/UploadImage';
import categoriesApi from '../../api/categories';
import { post_params } from '../../utils/constant';
import { dataSchema_type } from '../../utils/constant';
import usersApi from '../../api/users';
import Editor from '../../components/Editor';
import destinationsApi from '../../api/destinations';
import { debounce } from 'lodash';

const { Option } = Select;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const { TextArea } = Input;
export default function PostForm(props) {
  const isMount = useRef(false);
  const shortEditorRef = useRef();
  const fullTextEditorRef = useRef();
  const { onClose, currentData, open, onOpen } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingClose, setLoadingClose] = useState(false);
  const [cat, setCat] = useState([]);
  const [dest, setDest] = useState([]);
  const [errorMeta, setErrorMeta] = useState(null);
  const intl = useIntl();
  const [valueMeta, setValueMeta] = useState(null);
  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        let filter = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        };
        let categories = await categoriesApi.getAll(filter);
        let destinations = await destinationsApi.getAll(filter);
        setCat(categories.data);
        setDest(destinations.data);
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const [users, setusers] = useState([]);

  // side effects
  useEffect(() => {
    isMount.current = true;
    async function fetchData() {
      if (isMount) {
        let amenityItems = await usersApi.getAll({
          page: 1,
          limit: 9999,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
        });
        // console.log('operators: ', items);
        const amenitiesData = amenityItems?.data;
        if (Array.isArray(amenitiesData)) {
          setusers(
            amenitiesData.map((amenity) => ({
              label: `${amenity?.fullname}`,
              value: amenity.id,
            }))
          );
        }
      }
    }
    fetchData();
    return () => {
      isMount.current = false;
    };
  }, []);

  const handleSubmit = (close) => {
    if (close) {
      setLoadingClose(true);
    } else {
      setLoading(true);
    }

    form
      .validateFields()
      .then(async (values) => {
        let data = { ...values };
        data.featured = data.featured ? 1 : 0;
        const combinedObject = {};
        data.meta_data.forEach((item) => {
          const key = Object.keys(item)[0];
          const value = item[key];
          combinedObject[key] = value;
        });
        delete data.image;
        delete data.catIds;

        if (shortEditorRef.current) {
          // console.log('ref', shortEditorRef.current);
          const shortHtmlString = await shortEditorRef.current.getHtmlAsync();
          // console.log('shortHtmlString', shortHtmlString);
          data.short = shortHtmlString;
        } else {
          if (currentData && currentData.short) {
            data.short = currentData.short;
          } else {
            data.short = '';
          }
        }
        if (fullTextEditorRef.current) {
          // console.log('ref', fullTextEditorRef.current);
          const fullTextHtmlString =
            await fullTextEditorRef.current.getHtmlAsync();
          // console.log('fullTextHtmlString', fullTextHtmlString);
          data.fulltext = fullTextHtmlString;
        } else {
          if (currentData && currentData.fulltext) {
            data.fulltext = currentData.fulltext;
          } else {
            data.fulltext = '';
          }
        }

        const formData = new FormData();
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        if (imgs) {
          formData.append('image', imgs);
        }
        if (combinedObject) {
          formData.append('params', JSON.stringify(combinedObject));
        }
        form
          .getFieldValue('catIds')
          .map((data) => formData.append('catIds[]', data));
        if (currentData) {
          postApi
            .update(currentData.id, formData)
            .then((res) => {
              setLoading(false);
              setLoadingClose(false);
              if (close) {
                handleCancel();
              } else {
                onOpen(res);
              }
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
              setLoadingClose(false);
            });
        } else {
          postApi
            .create(formData)
            .then((res) => {
              setLoading(false);
              setLoadingClose(false);
              if (close) {
                handleCancel();
              } else {
                onOpen(res);
              }
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
              setLoadingClose(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    if (currentData && JSON.parse(currentData.params)) {
      if (
        JSON.parse(currentData.params).meta_description.length < 25 ||
        JSON.parse(currentData.params).meta_description.length > 160
      ) {
        setErrorMeta(
          'Meta description must be between 25 and 160 characters long.'
        );
      }
    }
  }, [currentData]);
  const handleOnchangeMetaDescription = debounce((e) => {
    const value = e.target.value;

    if (value) {
      setValueMeta(value);
      if (value.length < 25 || value.length > 160) {
        setErrorMeta(
          'Meta description must be between 25 and 160 characters long.'
        );
      } else {
        setErrorMeta(null);
      }
    }
  }, 300);
  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };
  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  let initialValue = {
    ...currentData,
    alias: currentData && currentData.alias ? currentData.alias : '',
    status: currentData && currentData.status ? 1 : 0,
    user_id:
      currentData && currentData.user_id ? Number(currentData.user_id) : '',
    catIds:
      currentData && currentData.categories
        ? currentData.categories.map((d) => d.id)
        : [],
    destination_id:
      currentData && currentData.destination
        ? Number(currentData.destination.id)
        : '',
    meta_data:
      currentData && currentData.params
        ? post_params.map((key) => ({
            [key]:
              currentData && currentData.params
                ? JSON.parse(currentData.params)[key] || ''
                : '',
          }))
        : post_params.map((key) => ({
            [key]: '',
          })),
  };
  // console.log('initialValue', currentData);

  const fileList = useMemo(
    () =>
      currentData && currentData.image
        ? [
            {
              uid: '1',
              name: 'image.png',
              status: 'done ',
              url: currentData.image,
            },
          ]
        : [],
    [currentData]
  );

  const [imgs, setImgs] = useState(null);

  const onChangeImage = (v, f) => {
    setImgs(f);
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.posts" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item label={<IntlMessages id="global.slug" />} name="slug">
            <Input />
          </Form.Item>

          <Form.Item
            name="catIds"
            label={<IntlMessages id="global.category" />}
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder={intl.formatMessage({
                id: 'placeholder.select_category',
              })}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {cat.map((option, index) => {
                return (
                  <Option key={`${option.id}_${index}`} value={option.id}>
                    {option.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="destination_id"
            label={<IntlMessages id="global.destination" />}
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Select
              showSearch
              allowClear
              placeholder={intl.formatMessage({
                id: 'global.select_destination',
              })}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {dest.map((option, index) => {
                return (
                  <Option key={`${option.id}_${index}`} value={option.id}>
                    {option.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="featured"
            label={<IntlMessages id="global.featured" />}
            valuePropName="checked">
            <Checkbox defaultChecked={initialValue.featured ? true : false}>
              Special
            </Checkbox>
          </Form.Item>
          <Form.Item name="status" label={<IntlMessages id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessages id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessages id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={<IntlMessages id="global.image" />} name="image">
            <UploadImage onChangeData={onChangeImage} initList={fileList} />
          </Form.Item>

          <Form.Item
            label={<IntlMessages id="global.image_alt" />}
            name="image_alt"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.users" />}
            name="user_id"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <Select
              showSearch
              placeholder={intl.formatMessage({ id: 'global.select_user' })}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {users.map((route, index) => (
                <Option key={route.value} value={route.value}>
                  {`${route.label}`}
                </Option>
              ))}
              ;
            </Select>
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessages id="post.short" />,
      className: 'contact_info',
      forceRender: true,
      children: (
        <>
          <Form.Item
            name="short"
            wrapperCol={24}
            rules={[
              {
                required: false,
              },
            ]}>
            <Editor
              htmlString={
                currentData && currentData.short ? currentData.short : null
              }
              editorRef={shortEditorRef}
            />
          </Form.Item>
        </>
      ),
    },
    {
      key: '3',
      label: <IntlMessages id="post.fulltext" />,
      className: 'contact_info',
      forceRender: true,
      children: (
        <>
          <Form.Item
            wrapperCol={24}
            name="fulltext"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   // console.log({ event, editor, data });
            //   return data;
            // }}
          >
            <Editor
              htmlString={
                currentData && currentData.fulltext
                  ? currentData.fulltext
                  : null
              }
              editorRef={fullTextEditorRef}
            />
          </Form.Item>
        </>
      ),
    },
    {
      key: '4',
      label: <IntlMessages id="global.meta_data" />,
      forceRender: true,
      children: (
        <>
          <Form.List name="meta_data">
            {(fields, { add }) => (
              <>
                {fields.map((field, index) => {
                  const param = post_params[index];

                  if (param === 'schema_type') {
                    return (
                      <Form.Item
                        key={field.key}
                        label={<IntlMessages id={`global.${param}`} />}
                        name={[index, param]}>
                        <Select
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }>
                          {dataSchema_type?.map((schema_type, index) => (
                            <Option key={schema_type} value={schema_type}>
                              {schema_type}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    );
                  } else if (param === 'meta_description') {
                    const metaDescriptionValue = form.getFieldValue([
                      'meta_data',
                      index,
                      param,
                    ]);
                    return (
                      <>
                        <Row gutter={[16, 16]}>
                          <Col key={index} span={6}></Col>
                          <Col key={index} span={18}>
                            ( {metaDescriptionValue.length}/160 )
                          </Col>
                        </Row>
                        <Form.Item
                          key={field.key}
                          label={<IntlMessages id={`global.${param}`} />}
                          validateStatus={errorMeta ? 'error' : ''}
                          help={errorMeta}
                          name={[index, param]}>
                          <TextArea
                            rows={4}
                            onChange={handleOnchangeMetaDescription}
                          />
                        </Form.Item>
                      </>
                    );
                  } else
                    return (
                      <Form.Item
                        key={field.key}
                        label={<IntlMessages id={`global.${param}`} />}
                        name={[index, param]}>
                        <Input />
                      </Form.Item>
                    );
                })}
              </>
            )}
          </Form.List>
          {/* <Form.Item
            label={<IntlMessages id="global.schema_type" />}
            name="schema_type"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Select a schema type"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {dataSchema_type?.map((schema_type, index) => (
                <Option key={schema_type} value={schema_type} >
                  {schema_type}
                </Option>
              ))}
            </Select>
          </Form.Item> */}
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      // onCancel={handleCancel}
      width="80%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={() => {
            handleSubmit(false);
          }}>
          {<IntlMessages id="global.save" />}
        </Button>,
        <Button
          key="submit&close"
          type="primary"
          htmlType="submit"
          loading={loadingClose}
          onClick={() => {
            handleSubmit(true);
          }}>
          {<IntlMessages id="global.save_and_close" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValue}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
